export default ({ id }) => `${id}`.startsWith('mo');